import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { RequestOptions, Headers, Http, Response } from '@angular/http';

import { Responsavel } from '../agendamento/responsavel';
import { ResponsavelService } from '../agendamento/responsavel.service';

import { Denuncia } from '../denuncia/denuncia';
import { DenunciasService } from '../denuncias/denuncias.service';

@Component({
  selector: 'app-agendamento',
  templateUrl: './agendamento.component.html',
  styleUrls: ['./agendamento.component.css'],
  providers: [
    ResponsavelService,DenunciasService
  ]
})
export class AgendamentoComponent implements OnInit {

  responsavel: Responsavel;

  resposta: Responsavel;

  respAgend: Responsavel[];

  responsaveis_incid: string;

  msg: string;

  public denuncia: Denuncia;

  public maskDH = [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /[1-2]/, /\d/, /\d/, /\d/, ' ', /[0-1-2]/, /\d/, ':', /[0-5]/, /\d/, ':', /[0-5]/, /\d/];
  public maskDH2 = [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /[1-2]/, /\d/, /\d/, /\d/, ' ', /[0-1-2]/, /\d/, ':', /[0-5]/, /\d/, ':', /[0-5]/, /\d/];

  constructor(private responsavelService: ResponsavelService, private denunciaService: DenunciasService, private router: Router, private http: Http, private route: ActivatedRoute) {
    this.responsavel = new Responsavel;
    this.http = http;
    this.denuncia = new Denuncia();
    this.responsavel = new Responsavel();
    this.resposta = new Responsavel();
  }

  getDadosDenuncia(): void{
    this.route.params.forEach((params: Params) => {
     let id = params['id']; // id da denuncia

    if (id !== undefined) {
      this.denunciaService.getDenuncia(id)
         .then((denuncia) => {this.denuncia = denuncia;});
    }

   });
 }


  getResponsaveis(): void {
     this.route.params.forEach((params: Params) => {
      let id = params['id']; // id do incidente

     if (id !== undefined) {
       this.responsavelService.getResponsaveis(id)
          .then((responsavel) => {this.responsaveis_incid = responsavel['dados'];});
     }

    });
  }

  getAgendamentos(): void {
     this.route.params.forEach((params: Params) => {
      let id = params['id']; // id do incidente

     if (id !== undefined) {
       this.responsavelService.getAgendamentosMarcados(id)
          .then((resposta) => {
            //console.log("resposta " + resposta['dados']);
            if (resposta['dados'] !== undefined) { // nenhum agendamento marcado
              this.msg = resposta['dados'];
            }
            else {
              this.respAgend = resposta;
            }
            //console.log(this.respAgend);
            //console.log("msg " + this.msg);
          });
     }

    });
  }


  setarNomeRelator(): void {
    this.responsavel.nomeEnt = this.denuncia.nomeDenunciante;
  }

  setarEmailRelator(): void {
    this.responsavel.emailEnt = this.denuncia.emailDenunciante;
  }

  ngOnInit() {
    this.getDadosDenuncia();
    this.getResponsaveis();
    this.getAgendamentos();
  }

  salvar(): void {
    this.route.params.forEach((params: Params) => {
     let id = params['id'];

     if (id !== undefined) {
       this.responsavel.id_incidente = id;
       this.responsavelService.saveData(this.responsavel)
           .then(() => this.goBack())
           .catch(erro => window.scrollTo(0,0));
     }

   });

  }

  goBack(): void {
     this.router.navigate(['/denuncias']);
  }

}



// WEBPACK FOOTER //
// ./src/app/agendamento/agendamento.component.ts